import { render } from "./LineItem.vue?vue&type=template&id=68961030&scoped=true"
import script from "./LineItem.vue?vue&type=script&lang=js"
export * from "./LineItem.vue?vue&type=script&lang=js"

import "./LineItem.vue?vue&type=style&index=0&id=68961030&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-68961030"

export default script